<div class="modal-header">
    <h2 mat-dialog-title trans>Move items</h2>
    <button type="button" mat-icon-button (click)="close()" class="close-button" tabindex="-1">
        <mat-icon svgIcon="close"></mat-icon>
    </button>
</div>

<form ngNativeValidate (ngSubmit)="confirm()">
    <mat-dialog-content>
        <folders-tree
            [expanded]="true"
            [disableContextMenu]="true"
            [showRootNode]="true"
            (folderSelected)="destination$.next($event)"
        ></folders-tree>
    </mat-dialog-content>

    <mat-dialog-actions>
        <button (click)="close()" type="button" mat-button class="cancel-button" trans>Cancel</button>
        <button type="submit" mat-raised-button color="accent" class="submit-button" [disabled]="!(canMove$ | async) || (loading$ | async)" trans>Move</button>
    </mat-dialog-actions>
</form>
